import { render, staticRenderFns } from "./nseriesOrderDetail.vue?vue&type=template&id=b257c7e4&scoped=true&"
import script from "./nseriesOrderDetail.vue?vue&type=script&lang=js&"
export * from "./nseriesOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./nseriesOrderDetail.vue?vue&type=style&index=0&id=b257c7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b257c7e4",
  null
  
)

export default component.exports